const {
    isBefore3Min,
    isTimeOut,
    isLoggedIn
  } = usePopup()
import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';

export default defineNuxtPlugin(() => {
    let interval27: ReturnType<typeof setInterval> | null = null
    let interval3: ReturnType<typeof setInterval> | null = null

    const { remainMs, is27Reached, is3Reached } = useSessionTimer()
    const TWENT_SEVEN_MIN = 27 * 60 * 1000
    const THREE_MIN = 3 * 60 * 1000

    const startFromLastAccess27 = (lastAccess: number) => {
        //기존 interval 정리dudu
        if(interval27) {
            clearInterval(interval27)
            interval27 = null
        }

        //시작 시 상태 초기화
        is27Reached.value = false;
        isBefore3Min.value = false;

        const authInfo  = useHconAuthInfo().getIfPossible();
        const targetTime = lastAccess + TWENT_SEVEN_MIN

        const tick = () => {
            const now = Date.now()
            const ms = targetTime - now
            remainMs.value = ms
            // console.log("남은 ms:",ms)
            // console.log("남은 초:", Math.floor(ms/1000))
            //27분 도달(= ms <= 0) 순간에 변수 변경
            if (ms <= 0) {
                is27Reached.value = true
                isBefore3Min.value = true
                startFromLastAccess3(now)
                //더 이상 카운트다운 필요 없으면 멈춤
                if (interval27) {
                    clearInterval(interval27)
                    interval27 = null
                } 

                
            }
        }

        tick()
        interval27 = setInterval(tick, 1000) //1초마다 실시간 갱신
    }

    const startFromLastAccess3 = (lastAccess: number) => {
        //기존 interval 정리dudu
        if(interval3) {
            clearInterval(interval3)
            interval3 = null
        }

        //시작 시 상태 초기화
        is3Reached.value = false;       

        const targetTime = lastAccess + THREE_MIN

        const tick = () => {
            const now = Date.now()
            const ms = targetTime - now
            remainMs.value = ms
            // console.log("2남은 ms:",ms)
            // console.log("2남은 초:", Math.floor(ms/1000))
            //27분 도달(= ms <= 0) 순간에 변수 변경
            if (ms <= 0) {
                is3Reached.value = true
                isLoggedIn.value = false;
                isTimeOut.value = true;
                useHconAuthInfo().clear();
                SessionStorageSynchronizer.removeItem('common.auth.rememberMe');
                //더 이상 카운트다운 필요 없으면 멈춤
                if (interval3) {
                    clearInterval(interval3)
                    interval3 = null
                } 

                localStorage.setItem('auth:event', JSON.stringify({
                    type: 'LOGOUT',
                    at: Date.now()
                }));
            }
        }

        tick()
        interval3 = setInterval(tick, 1000) //1초마다 실시간 갱신
    }

    const stopTimer = () => {
        if (interval27) {
            clearInterval(interval27)
            interval27 = null
        }

        if (interval3) {
            clearInterval(interval3)
            interval3 = null
        }
    }

    return {
        provide: {
            start27Timer: startFromLastAccess27,
            start3Timer: startFromLastAccess3,
            stopTimer: stopTimer,
        }
    }
})